export const MEETINGS_ACCENT = "#4F46E5";

export const MEETING_STATUS_LABELS: Record<string, string> = {
  preparation: "הכנה",
  scheduled: "מתוכננת",
  completed: "הושלמה",
  cancelled: "בוטלה",
};

export const MEETING_STATUS_COLORS: Record<string, string> = {
  preparation: "#6366F1",
  scheduled: "#0EA5E9",
  completed: "#10B981",
  cancelled: "#9CA3AF",
};

export const PARTICIPANT_KIND_LABELS: Record<string, string> = {
  regular: "קבוע",
  guest: "אורח",
};

export const MEETING_ROLE_LABELS: Record<string, string> = {
  chair: 'יו"ר',
  secretary: "מזכיר",
  gabay: "גבאי",
  member: "חבר צוות",
  guest: "אורח",
};

export const MEETING_ROLE_OPTIONS = Object.entries(MEETING_ROLE_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export const PARTICIPANT_KIND_OPTIONS = Object.entries(PARTICIPANT_KIND_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export const ACTION_STATUS_LABELS: Record<string, string> = {
  open: "פתוח",
  in_progress: "בטיפול",
  done: "הושלם",
  cancelled: "בוטל",
};

export const PHASES = [
  { key: "prep" as const, label: "הכנת ישיבה" },
  { key: "summary" as const, label: "סיכום דיון" },
  { key: "archive" as const, label: "ישיבות קודמות" },
];

export type MeetingPhase = (typeof PHASES)[number]["key"];

export function formatMeetingDateTime(dt: string | null | undefined): string {
  if (!dt) return "—";
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("he-IL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function splitMeetingDatetime(dt: string | null | undefined): {
  date: string;
  time: string;
} {
  if (!dt) return { date: "", time: "" };
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return { date: "", time: "" };
  const pad = (n: number) => String(n).padStart(2, "0");
  return {
    date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
    time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
  };
}

/** Merge local date + time into ISO datetime for the platform API. */
export function mergeMeetingDatetime(
  date: string,
  time: string,
): string | null {
  if (!date) return null;
  const t = time || "09:00";
  const d = new Date(`${date}T${t}:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function daysUntil(dt: string | null | undefined): number | null {
  if (!dt) return null;
  const target = new Date(dt);
  const now = new Date();
  if (Number.isNaN(target.getTime())) return null;
  target.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
}

export function toDateInputValue(dt: string | null | undefined): string {
  if (!dt) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dt)) return dt;
  const d = new Date(dt);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
